export default __webpack_public_path__ + "static/media/element_65.b329d354.webp";